import React, {Component} from 'react';
import Alert from '../common/Alert';

import api from '../../config/api';
import shopImage1 from '../../media/shop-image-1.jpg';
import LandingWithMessageFrom from "../form/LandingWithMessageFrom";

class WebshopLandingPage extends Component {

	constructor() {
		super();
		this.state = {
			name: '',
			email: '',
			phone: '',
			message: '',
			alertMessage: '',
			alertType: '',
			alertRendered: false,
			contactButtonDisabled: false
		};
	}

	setContactButtonState = (state) => {
		this.setState({
			contactButtonDisabled: state
		});
	};

	setForm = (name, value) => {
		this.setState({
			[name]: value
		});
	};

	sendForm = () => {

		if (this.state.name.length <= 0 ||
			this.state.email.length <= 0 ||
			this.state.phone.length <= 0 ||
			this.state.message.length <= 0) {
			this.setState({
				alertMessage: "A név, a telefonszám és az email kötelező mezők!",
				alertType: "FAIL",
				alertRendered: true,
				contactButtonDisabled: false,
			});
			return;
		}

		const options = {
			method: 'POST',
			body: JSON.stringify({
				name: this.state.name,
				email: this.state.email,
				phone: this.state.phone,
				message: this.state.message
			}),
			headers: new Headers({
				'Content-Type': 'application/json'
			})
		};

		fetch(api.landingWithMessage('WEBSHOP'), options)
			.then(res => res.json())
			.then(data => this.setState({
				name: data.status.includes('FAIL')? this.state.name : '',
				phone: data.status.includes('FAIL')? this.state.phone : '',
				email: data.status.includes('FAIL')? this.state.email : '',
				message: data.status.includes('FAIL')? this.state.message : '',
				alertMessage: data.text,
				alertType: data.status,
				alertRendered: true,
				contactButtonDisabled: false,
			}))
			.catch(err => {
				console.log(err);
				this.setState({
					alertMessage: 'Valami hiba történt, próbálja meg később!',
					alertType: 'FAIL',
					alertRendered: true,
					contactButtonDisabled: false
				})
			});
	};

	render() {

		const { alertType, alertMessage, alertRendered, contactButtonDisabled, email, name, phone, message} = this.state;

		return (
			<div className="container-flex">
				<div className="page__banner page__banner--webshop">
				</div>
				<div className="page page--landing page--webshop">
					<section className="landing-info">
						<h2 className="color-red">MEGNYITOTTUNK!</h2>
						<h3 className="color-blue"><strong>Címünk:</strong> Nagytarcsa 2142, Ganz Ábrahám utca 3. (a Berdó Ipari Parkban)<br/>
							<strong>Telefon:</strong> 06-30-455-2342 <strong>E-mail:</strong> bolt@amikohome.com <strong>Nyitva:</strong> H-P: 8:30-17:00</h3>
					</section>
					<section className="landing-program">
						<div className="landing-program__dates">
							<p><strong>Nyitási akciókkal</strong> várjuk minden <br/> viszonteladó, telepítő és <br/> végfelhasználó vásárlónkat!</p>
							<p>Termékeinket megtalálja a <br/> <a href="https://www.amikohome.com/hu">www.amikohome.com/hu</a> <br/> oldalon.</p>
							<p><strong>Árainkért érdeklődjön munkatársainknál!</strong></p>
							<div className="embed-responsive embed-responsive-16by9">
								<iframe className="embed-responsive-item"
								        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10779.0806705689!2d19.286971!3d47.513867!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd5693eba2cedc060!2sAMIKO+HOME+M%C3%A1rkabolt!5e0!3m2!1sen!2shu!4v1543222710163"
								        frameBorder="0" style={{border:0}} allowFullScreen></iframe>
							</div>
						</div>
						<div className="landing-program__images">
							<img className="img-responsive" src={shopImage1} alt="AMIKO HOME Márkabolt"/>
						</div>
					</section>
					<section className="landing-form">
						<h3>Kérdése van? Munkatársaink örömmel állnak a rendelkezésére!</h3>
						<Alert alertType={alertType}
						       alertMessage={alertMessage}
						       rendered={alertRendered} />
						<LandingWithMessageFrom setForm={this.setForm}
						             sendForm={this.sendForm}
						             contactButtonDisabled={contactButtonDisabled}
						             setContactButtonState={this.setContactButtonState}
						             name={name} email={email} phone={phone} message={message}/>
					</section>
					<section className="landing-info">
						<h2>Várjuk Önt is sok szeretettel!</h2>
						<h3>- AMIKO HOME Márkabolt</h3>
					</section>
				</div>
			</div>
		);
	}
}

export default WebshopLandingPage;


// WEBPACK FOOTER //
// ./src/components/landing/WebshopLandingPage.js